import { render } from "./ElectricityTable.vue?vue&type=template&id=8bdcd03c"
import script from "./ElectricityTable.vue?vue&type=script&lang=js"
export * from "./ElectricityTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__